<div class="screen">
  <div class="screen-inner">
    <header class="topbar">
      <span></span>
      <h1 class="topbar-title">Event signup</h1>
      <span></span>
    </header>

    @if (event) {
      <section class="hero">
        <h2 class="hero-title">{{ event.name }}</h2>
        <p class="hero-meta">{{ event.leagueName }} · {{ event.formatLabel }}</p>
        <p class="hero-meta">
          {{ event.startDate }}@if (event.endDate !== event.startDate) { <span> to {{ event.endDate }}</span> }
          · {{ event.entryFee }} entry
        </p>
      </section>

      @if (!auth.isAuthenticated()) {
        <a class="btn-primary" [routerLink]="loginLink()">Sign in to sign up</a>
      } @else {
        <form class="form" (ngSubmit)="signup()">
          @if (event.ctpEnabled || event.longDriveEnabled) {
            <p class="section-label">Side games</p>
          }
          @if (event.ctpEnabled) {
            <label class="field-check">
              <input name="ctp" type="checkbox" [(ngModel)]="ctpEntered" />
              <span>Closest to the pin &mdash; {{ event.ctpEntryFee }}</span>
            </label>
          }
          @if (event.longDriveEnabled) {
            <label class="field-check">
              <input name="ld" type="checkbox" [(ngModel)]="longDriveEntered" />
              <span>Long drive &mdash; {{ event.longDriveEntryFee }}</span>
            </label>
          }
          <button class="btn-primary" type="submit">Sign me up</button>
          <p class="field-hint">Pay the organizer at the range. They mark you paid in the app.</p>
        </form>
      }
    }

    @if (error) { <p class="error">{{ error }}</p> }
  </div>
</div>
